import styled from "styled-components";
import { AddButton } from "../../../../../App/Common/Components/FormComponents";
import { DropDownMessage } from "../../../../../App/Common/Styles/DNDImage";
import { IDocumentSettings } from "../../../../../components/course-author/types";
import { DividerColorFieldSet, SelectorFieldSet } from "../separator/DividerPart.styles";
import { ColourInput } from "../separator/SpacerPart.styles";
import { mkImageUrl } from "../image/ImagePart";

export const DocDnDMessage = styled(DropDownMessage)`
  font-size: 2.2rem;
  font-weight: 600;
  text-align: center;
`;

export const SupportedFilesMessage = styled(DropDownMessage)`
  color: ${({ theme }) => theme.colors.darkblue};
  opacity: 0.5;
  white-space: pre-line;
  text-align: center;
  font-size: 1.6rem;
`;

export const DocumentDndBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  height: 20vh;
  border-radius: 5px;
  border: 2px dashed #21394f;
  background: #f6f6f6;
  width: 100%;
`;

export const DocumentAddButton = styled(AddButton)`
  width: 10%;
  margin-top: 1.2rem;
`;

export const ImportURLContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 2rem;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2.4rem;
`;

interface PDFContainerProps {
  settings: IDocumentSettings["settings"];
}

export const PDFViewerContainer = styled.div<PDFContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${({ settings }) =>
    settings.size === "full-width" ? "900px" : settings.size === "medium" ? "600px" : "300px"};
  margin: ${({ settings }) => `${settings.margin}px`} 0;
  padding: 2rem 0;
  background: ${({ settings }) =>
    settings.hasBackground &&
    (settings.backgroundImageId
      ? `url(${mkImageUrl(settings.backgroundImageId)})`
      : settings.size !== "full-width" && settings.hasBackground && settings.backgroundColor)};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export const PDFObjectContainer = styled.div<PDFContainerProps>`
  height: 100%;
  width: ${({ settings }) => (settings.size === "full-width" ? "100%" : settings.size === "medium" ? "50%" : "25%")};
  border: ${({ settings }) =>
    settings.style === "border"
      ? `${settings.borderThickness}px ${settings.borderStyle} ${settings.borderColor}`
      : "none"};
  box-sizing: border-box;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 1.6rem;
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  align-self: flex-start;
`;

export const DocSelectorFieldSet = styled(SelectorFieldSet)`
  align-self: flex-start;
  height: 100%;
`;

export const BackgroundImageFieldSet = styled(DividerColorFieldSet)`
  margin: 0;
  width: 160px;
`;

export const DocColourInput = styled(ColourInput)`
  padding: 0;
  height: auto;
  margin: 0;
  height: 2.5rem;
`;

export const PostUploadBox = styled(DocumentDndBox)`
  height: auto;
  justify-content: flex-start;
  cursor: default;
  padding: 1.5rem 3rem 4rem;
  width: 80%;
  font-weight: 600;
`;

export const IconsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 1.6rem;
`;

export const DocInfoContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;

export const DocInfoText = styled.span`
  white-space: pre-line;
`;

export const ProgressBarContainer = styled.div`
  width: 90%;
  display: flex;
  gap: 1.6rem;
  align-items: center;
`;

export const ProgressBar = styled.progress`
  width: 100%;
  accent-color: ${({ theme }) => theme.colors.darkblue};
`;

export const BackgroundOptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.6rem;
  align-items: center;
`;

export const ClickableBackgroundDropdown = styled.div<PDFContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  cursor: pointer;
  background: ${({ settings }) =>
    settings.backgroundImageId ? `url(${mkImageUrl(settings.backgroundImageId)})` : "none"};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 5px;
  border: 2px solid #21394f;
`;
